import * as sup from "superstruct";

import {
  createRouting,
  defineRoute,
} from "@/modules/router/utils/createRouting/createRouting";

export const anonymousRouting = createRouting({
  signIn: defineRoute({
    path: "/sign-in" as const,
  }),
  resetPassword: defineRoute({
    path: "/reset" as const,
    queryStruct: sup.object({
      token: sup.string(),
    }),
  }),
  setupPassword: defineRoute({
    path: "/setup-password" as const,
    queryStruct: sup.object({
      token: sup.string(),
    }),
  }),
  resetPasswordConfirmation: defineRoute({
    path: "/reset-password-confirmation" as const,
  }),
  resetPasswordSuccess: defineRoute({
    path: "/reset-password-success" as const,
  }),
  setupPasswordSuccess: defineRoute({
    path: "/setup-password-success" as const,
  }),
});
